// extracted by mini-css-extract-plugin
export var fadeInAnimation = "HeroVideo-module--fadeInAnimation--3010e";
export var show = "HeroVideo-module--show--1930e";
export var video = "HeroVideo-module--video--70041";